define('views/modules/questionnaire/responses/answers/answer-comment-form',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'src/views/form-view',
    'views/parts/form/textarea',
    // templates
    'text!templates/modules/questionnaire/responses/answers/answer-comment-form.html',
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VForm,
    VTextarea,
    // templates
    TAnswerCommentForm
) {

    var VAnswerCommentForm = Backbone.View.extend({
        template: TAnswerCommentForm,

        regions: {
            comment: '.comment-input',
        },

        initialize: function(opt) {
            this.options = opt || {};

            this.answer = this.options.answer;

            this.view = {
                comment: new VTextarea({
                    rows: 2,
                    attribute: 'comment',
                    model: this.answer
                }),
            };

            this.listenTo(this.answer, 'change:comment', this.onCommentChange);
        },

        render: function() {
            // append the form
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.comment, zone.$comment);

            return this;
        },

    });

    return VAnswerCommentForm;
});

